<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="12"
            categoryName="Shroud"
            categorySectionIcon="fa-wrench"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'shroud',
    components: { BaseInventory }
}
</script>
